// jQuery
import $ from "jquery";

// Bootstrap
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/scrollspy';

// Lazysizes
import lazySizes from 'lazysizes';

// Lightbox
import GLightbox from 'glightbox';
const lightbox = GLightbox({
    loop: true
});

// Custom
import './custom/megamenu';

// AOS
import AOS from 'aos';

// Plyr
import Plyr from 'plyr';
const players = Plyr.setup('.video-player', {
    controls: [
        'play-large',
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'fullscreen'
    ],
    youtube: {
        noCookie: false,
        rel: 0,
        showinfo: 0,
        modestbranding: 1
    }
});

const homeVideo = Plyr.setup('.home-player', {
    controls: [
        'play-large',
    ]
});

// Contains function
Array.prototype.contains = function(obj) {
    var i = this.length;
    while (i--) {
        if (this[i] == obj) {
            return true;
        }
    }
    return false;
}

// Swiper
import Swiper, {
    Navigation,
    Pagination,
    Autoplay
} from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

const homeSlider = new Swiper('.home-slider .slider.swiper-container', {
    spaceBetween: 0,
    slidesPerView: 1,
    autoHeight: true,
    loop: false,
    speed: 1000,
    autoplay: {
        delay: 7000,
    },
    pagination: {
        el: '.slider-pagination',
        clickable: true,
    },
    navigation: false,
});

homeSlider.on('slideChangeTransitionStart', function() {
    let indexSlide = homeSlider.activeIndex,
        currentSlide = homeSlider.slides[indexSlide],
        animItems = currentSlide ? currentSlide.querySelectorAll('[data-aos]') : [];

    if (animItems && animItems.forEach) {
        animItems.forEach(function(el) {
            el.classList.remove('aos-animate');
            el.classList.remove('aos-init');
        });
    }
});

homeSlider.on('slideChangeTransitionEnd', function() {
    AOS.init({
        duration: 500,
        disable: 'mobile',
    });
});

homeSlider.on('slideChange', function() {
    let indexSlide = homeSlider.activeIndex,
        currentSlide = homeSlider.slides[indexSlide];

    if (currentSlide && currentSlide.classList.contains('slide-video')) {
        let currentVideo = currentSlide.querySelector("video");
        if (currentVideo) {
            currentVideo.currentTime = 0;
            currentVideo.play();
        }
    } else {
        if (homeVideo && Array.isArray(homeVideo)) {
            homeVideo.forEach(function(player) {
                if (player && player.pause) player.pause();
            });
        }
    }
});

const slider = new Swiper('.block-slider .slider.swiper-container', {
    spaceBetween: 0,
    slidesPerView: 1,
    autoHeight: true,
    loop: $('.block-slider .swiper-slide').length > 1,
    watchOverflow: true,
    speed: 500,
    pagination: {
        el: '.slider-pagination',
        clickable: true,
    },
    navigation: false,
});

const products = new Swiper('.block-products .products.swiper-container', {
    spaceBetween: 0,
    slidesPerView: 1,
    autoHeight: true,
    watchOverflow: true,
    centerInsufficientSlides: true,
    observer: true,
    observeParents: true,
    navigation: {
        prevEl: '.product-prev',
        nextEl: '.product-next',
        disabledClass: 'disabled',
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
            center: $('.swiper-slide').length < 2,
        },
        992: {
            slidesPerView: 3,
            center: $('.swiper-slide').length < 3,
        },
    },
});

const gallery = new Swiper('.block-gallery .gallery.swiper-container', {
    slidesPerView: 2,
    slidesPerGroup: 1,
    centeredSlides: true,
    spaceBetween: 30,
    autoHeight: true,
    loop: false,
    watchOverflow: true,
    centerInsufficientSlides: true,
    pagination: {
        el: '.gallery-pagination',
        clickable: true,
    },
    navigation: false,
    breakpoints: {
        0: {
            slidesPerView: 2,
            slidesPerGroup: 1,
        },
        1400: {
            slidesPerView: 4,
            slidesPerGroup: 1,
        },
    },
});

const gallery_vert = new Swiper('.block-gallery-vert .gallery.swiper-container', {
    spaceBetween: 0,
    slidesPerView: 1,
    autoHeight: true,
    watchOverflow: true,
    navigation: false,
    pagination: {
        el: '.vert-pagination',
        clickable: true,
        renderBullet: function(index, className) {
            return `<div class="${className}">${this.slides[index]?.getAttribute('data-title') || ''}</div>`;
        },
    },
});

const sectors = new Swiper('.block-sectors .sectors.swiper-container', {
    spaceBetween: 0,
    slidesPerView: 1,
    watchOverflow: true,
    centerInsufficientSlides: true,
    navigation: {
        prevEl: '.sector-prev',
        nextEl: '.sector-next',
        disabledClass: 'disabled',
    },
    breakpoints: {
        0: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
        992: {
            slidesPerView: 4,
        },
    },
});

AOS.init();

// jQuery Functions
$(document).ready(function() {
    $('body').addClass('loaded');

    // Bootstrap Scrollspy
    if ($("#scrollspy").length) {
        $('body').scrollspy({
            target: '#scrollspy',
            offset: headerHeight + extraHeight + 1,
        });
    }
});

// Conditional JS for large screens

document.addEventListener("DOMContentLoaded", function() {
    console.log('A DIGITAL PROJECT BY\n\r······································································································\n\r·oooo·································································································\n\r·oooo·································································································\n\r·oooo······················oooo·······································································\n\r·oooo·································································································\n\r·oooo·································································································\n\r·oooo····oooooo············oooo······oooooooooooooooo·········ooooooooo···············oooooooooo······\n\r·oooooooooooooooooo········oooo·····ooooooooooooooooo······ooooooooooooooo·········oooooooooooooooo···\n\r·oooooooo······ooooo·······oooo················ooooo·····ooooo·········ooooo·····ooooo··········ooooo·\n\r·ooooo···········ooooo·····oooo··············ooooo······ooooo···········ooooo····ooo·············oooo·\n\r·oooo·············oooo·····oooo·············ooooo·······ooooooooooooooooooooo···oooo··············ooo·\n\r·oooo·············oooo·····oooo···········ooooo·········oooo····················oooo··············ooo·\n\r·oooo·············oooo·····oooo··········oooo···········oooo····················oooo··············ooo·\n\r··ooooo·········ooooo······oooo········ooooo·············oooo···········oooo····oooo··············ooo·\n\r····oooooooooooooooo·······oooo······ooooooooooooooo······oooooo······ooooo·····oooo··············ooo·\n\r·······oooooooooo··········oooo·····ooooooooooooooooo········oooooooooooo·······oooo··············ooo·\n\r······································································································\n\r');


    // let mouseTarget = document.getElementsByClassName('home-slider')[0];

    // if (mouseTarget) {
    //     mouseTarget.addEventListener('mouseenter', e => {
    //         homeSlider.autoplay.stop();
    //         console.log('stop')
    //     });

    //     mouseTarget.addEventListener('mouseleave', e => {
    //         homeSlider.autoplay.start();
    //         console.log('play')
    //     });
    // }

});